import { Pie, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Pie,
  mixins: [reactiveProp],
  props: ["chartData", "labels", "color"],
  mounted() {
    this.renderChart(
      {
        hoverBorderWidth: 10,
        labels: this.labels,
        datasets: [
          {
            backgroundColor: this.color,
            data: this.chartData,
          },
        ],
      },
      {
        hoverBorderWidth: 150,
        legend: {
          display: false,
        },
      }
    );
  },
};
